import { Controller } from "@hotwired/stimulus"

// Keeps the quantity unit badge in sync when an ingredient is chosen.
export default class extends Controller {
  static targets = ["unit"]

  connect() {
    this.element.addEventListener("combobox:change", this.onComboboxChange)
  }

  disconnect() {
    this.element.removeEventListener("combobox:change", this.onComboboxChange)
  }

  onComboboxChange = (event) => {
    if (!this.hasUnitTarget) return
    const unit = (event.detail?.unit || "").toString().toLowerCase()
    this.unitTarget.textContent = unit || "qty"
  }
}
